module.exports = __webpack_public_path__ + "resources/img/img_secureguard_am3_m.3d5c001d2bc25cc31cfc4a1e97018df2.png";